export default "__VITE_ASSET__4286e42f__"